import { useTranslation } from "react-i18next";

import css from "./footer.module.scss";
import { HotBadge } from "./hot_badge";

interface RolePositionFooterProps {
  isHotVisible?: boolean;
  interestedIn?: number;
}

export const RolePositionFooter = ({ isHotVisible, interestedIn }: RolePositionFooterProps) => {
  const { t } = useTranslation();
  const hasInterested = !!interestedIn && interestedIn > 0;

  return (
    <div className={css.wrapper}>
      {isHotVisible && <HotBadge />}
      {hasInterested && <div className={css.right}>{t("interestedCount", { count: interestedIn })}</div>}
    </div>
  );
};
